import useFetch from '~api/useFetch';
import {ApiEndpoints} from '~constants/api';
import useDebouncedQuery from '~hooks/useDebouncedQuery';

export type PlotsSuggestionsResponse = {
    address: string;
    id: number;
}[];

const matchPlotAddress = (text: string) => text.length > 2;

export default function useFetchPlotsSuggestions(searchTerms: string) {
    const {apiGet} = useFetch();

    return useDebouncedQuery(
        500,
        [ApiEndpoints.PlotsSuggestions, searchTerms],
        () =>
            matchPlotAddress(searchTerms)
                ? apiGet<PlotsSuggestionsResponse>(ApiEndpoints.PlotsSuggestions, {
                      queryParams: {
                          query: searchTerms,
                          limit: 10,
                      },
                  })
                : null,
        {
            staleTime: 1000 * 60,
            cacheTime: 1000 * 60,
            refetchOnWindowFocus: false,
            retry: 1,
            retryDelay: 1000,
        },
    );
}
